import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

export default function ClickableStatCard({ label, value, to, accent, icon }) {
  const navigate = useNavigate();

  return (
    <motion.button
      type="button"
      onClick={() => to && navigate(to)}
      className={`glass-card text-left w-full group ${to ? '' : '!cursor-default hover:shadow-soft'}`}
      whileHover={{ scale: 1.03, y: -4 }}
      whileTap={{ scale: 0.98 }}
      transition={{ type: 'spring', stiffness: 400, damping: 25 }}
    >
      <div className="flex items-start justify-between">
        <p className="text-xs uppercase tracking-wider text-lumora-text/50">{label}</p>
        {icon && <span className="text-lumora-gold/80 text-lg">{icon}</span>}
      </div>
      <p
        className={`text-2xl font-serif font-medium mt-2 ${
          accent ? 'text-lumora-wood' : 'text-lumora-dark-wood'
        }`}
      >
        {value}
      </p>
      {to && (
        <p className="text-xs text-lumora-wood/60 mt-3 opacity-0 group-hover:opacity-100 transition-opacity">
          View details →
        </p>
      )}
    </motion.button>
  );
}
